/**
 * OOS-Availability — Runtime-Teil.
 *
 * Die gesamte Darstellung (CTA, Klaviyo, Statuszeile) hängt an EINEM Attribut:
 * data-oos-eff auf `main .product-single__wrapper`. Berechnet wird der Zustand
 * ausschließlich von window.__oosResolve (kanonisch definiert im Inline-Script
 * in snippets/product.liquid, das schon während des Parsens läuft und den
 * Session-Zustand vor dem ersten Paint setzt).
 *
 * Dieses Script schreibt zur LAUFZEIT dasselbe Attribut nach:
 *   - jedes change-Event → synchron (die Radio-Auswahl ist zu dem Zeitpunkt
 *     final; Verzögern wäre fatal, weil der Theme-Handler den Main-Thread nach
 *     einem Wechsel teils sekundenlang blockiert und Timer erst danach feuern)
 *   - DOM-Mutationen (Klaviyo-Injection etc.) → Debounce mit harter Obergrenze
 * Außerdem: Vorbestell-Wochentext + Größen-Glocken.
 * Es fasst weder Button-Text noch disabled/display an — das macht CSS.
 */
(function () {
  'use strict';

  function boot() {
    var W = document.querySelector('main .product-single__wrapper');
    if (!W) return;
    var mapEl = W.querySelector('[data-oos-availability]');
    if (!mapEl || !window.__oosResolve) return;
    var map = null;
    try { map = JSON.parse(mapEl.textContent || '{}'); } catch (e) {}
    if (!map) return;

    var sessionOk = W.getAttribute('data-size-session') === 'true';
    var norm = function (x) { return x == null ? '' : String(x).toLowerCase(); };

    function checkedValue(name) {
      var i = W.querySelector('input[name="options[' + name + ']"]:checked');
      return i ? i.value : null;
    }

    /** Effektive Größe: gewählte Radio > Session-Key (den auch theme.js zum
     *  Wiederherstellen nutzt) > keine. So liefert die Laufzeit dieselbe Antwort
     *  wie der Pre-Paint-Resolver — auch bevor das Theme die Radio gecheckt hat. */
    function sizeSel() {
      var s = checkedValue('Größe');
      if (s) return s;
      if (sessionOk) {
        try {
          var v = JSON.parse(sessionStorage.getItem('__selected_size'));
          if (v) return v;
        } catch (e) {}
      }
      return null;
    }

    function apply() {
      var eff = window.__oosResolve(map, checkedValue('Farbe'), checkedValue('Menge'), sizeSel());
      if (!eff) return;
      if (W.getAttribute('data-oos-eff') !== eff.state) W.setAttribute('data-oos-eff', eff.state);
      window.__oosEff = eff;

      if (eff.state === 'preorder' || eff.state === 'agg-preorder') {
        var t = window.__oosWeeksText ? window.__oosWeeksText(eff.eta) : '';
        var els = W.querySelectorAll('[data-oos-preorder-text]');
        for (var i = 0; i < els.length; i++) {
          if (t && els[i].textContent.trim() !== t) els[i].textContent = t;
        }
      }

      /* Zweite Sicherung neben pointer-events: nicht kaufbare Zustände hart
         deaktivieren. CSS allein schützt nur vor Maus-Klicks — nicht vor
         Tastatur-Submit oder fremdem JS. Text/Farbe/Sichtbarkeit bleiben
         ausschließlich CSS-gesteuert. */
      var buyable = eff.state === 'instock' || eff.state === 'preorder';
      var btns = W.querySelectorAll('[data-add-to-cart]');
      for (var b = 0; b < btns.length; b++) {
        if (btns[b].disabled !== !buyable) btns[b].disabled = !buyable;
      }

      applyBells();
    }

    /** Größen-Glocken: nur an Größen, deren Variante (aktuelle Farbe/Menge)
     *  notify ist. Sichtbarkeit macht CSS über data-oos-bell. */
    function applyBells() {
      var color = checkedValue('Farbe');
      var menge = checkedValue('Menge');
      var sizes = W.querySelectorAll('input[name="options[Größe]"]');
      for (var i = 0; i < sizes.length; i++) {
        var span = sizes[i].closest('.radio__button');
        if (!span) continue;
        var notify = false;
        for (var id in map) {
          var v = map[id];
          if (!v || !v.o) continue;
          if (norm(v.o[0]) !== norm(sizes[i].value)) continue;
          if (color != null && norm(v.o[1]) !== norm(color)) continue;
          if (menge != null && norm(v.o[2]) !== norm(menge)) continue;
          notify = v.state === 'notify' && !v.a;
          break;
        }
        if (notify) {
          if (span.getAttribute('data-oos-bell') !== 'notify') span.setAttribute('data-oos-bell', 'notify');
        } else if (span.hasAttribute('data-oos-bell')) {
          span.removeAttribute('data-oos-bell');
        }
      }
    }

    // Hinweis: Ein frueheres Swatch-Link-Retargeting (Groesse in die Ziel-URL
    // schreiben) entfaellt. Die Groesse reist ueber sessionStorage.__selected_size
    // und wird auf der Zielseite vom Pre-Paint-Resolver aufgeloest; die Menge
    // schreibt das Theme selbst korrekt in die Swatch-Links (updateProductInfo).
    // Das Retargeting hatte mit genau diesem Theme-Code ein Race.

    // --- Auslöser -----------------------------------------------------------
    // Sliding-Debounce (120 ms) MIT harter Obergrenze: Das Theme feuert bei einem
    // Variantenwechsel hunderte DOM-Mutationen in Folge — ohne Deckel würde die
    // Debounce ausgehungert und der Zustand käme sekundenlang nicht nach. Da der
    // Resolver rein zustandsbasiert ist (Radios + Session), ist ein Lauf mitten
    // im Sturm unschädlich: er liefert bereits das korrekte Endergebnis.
    var qt = null, qDeadline = 0;
    function quiet() {
      var now = Date.now();
      if (qt) clearTimeout(qt);
      else qDeadline = now + 300;
      var wait = Math.min(120, Math.max(16, qDeadline - now));
      qt = setTimeout(function () { qt = null; apply(); }, wait);
    }

    apply();

    // JEDES change synchron anwenden — auch programmatische. Zum Zeitpunkt des
    // Events ist die Radio-Auswahl bereits final, der Resolver liefert also das
    // korrekte Ergebnis. Verzögern wäre fatal: der Theme-Handler blockiert nach
    // einem Variantenwechsel den Main-Thread teils sekundenlang, Timer feuern
    // dann erst viel später (sichtbar veralteter Zustand).
    document.addEventListener('change', function () { apply(); }, true);

    // Theme/Klaviyo-DOM-Änderungen im Buy-Bereich nachziehen. apply() ist
    // idempotent (schreibt nur bei Differenz) — kein Observer-Ping-Pong.
    try {
      new MutationObserver(function () { quiet(); })
        .observe(W, { childList: true, subtree: true, attributes: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
